const parseUnit = (value, size) => {
  if (value.endsWith('%')) {
    // Convert percentage values to pixels,
    // since percentage values in SVG are calculated relative to the SVG viewport itself
    return ((parseFloat(value) || 0) * size) / 100;
  }

  return parseFloat(value) || 0;
};

const parseRadius = (rawRadius, width, height) => {
  const [xRaw, yRaw = xRaw] = rawRadius.trim().split(/\s+/);

  return {
    horizontal: parseUnit(xRaw, width),
    vertical: parseUnit(yRaw, height),
  };
};

const getBorderRadius = (computedStyles, width, height) => {
  const {
    borderTopLeftRadius = '0px',
    borderTopRightRadius = '0px',
    borderBottomRightRadius = '0px',
    borderBottomLeftRadius = '0px',
  } = computedStyles;

  return {
    topLeft: parseRadius(borderTopLeftRadius, width, height),
    topRight: parseRadius(borderTopRightRadius, width, height),
    bottomRight: parseRadius(borderBottomRightRadius, width, height),
    bottomLeft: parseRadius(borderBottomLeftRadius, width, height),
  };
};

export default getBorderRadius;
